/**
 * Encode finalize transaction for Gnosis Safe
 */
import type { Address } from "viem"
import { encodeFunctionData } from "viem"
import { breakoutMarketAbi } from "../../abi/generated/breakoutMarket"
import type { SafeTransaction } from "../../types"

export interface EncodeFinalizeParams {
	market: Address
	/** The nonce from resolution (must match current resolution nonce) */
	nonce: number
}

/**
 * Encode a finalize transaction for Gnosis Safe
 *
 * @example
 * ```ts
 * import { encodeFinalize } from "@breakout/sdk/actions/encode"
 *
 * const safeTx = encodeFinalize({ market: "0x...", nonce: 1 })
 * ```
 */
export function encodeFinalize(params: EncodeFinalizeParams): SafeTransaction {
	const data = encodeFunctionData({
		abi: breakoutMarketAbi,
		functionName: "finalize",
		args: [params.nonce],
	})

	return {
		to: params.market,
		value: "0",
		data,
	}
}
